import {
  VStack,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Drawer,
  DrawerContent,
  DrawerCloseButton,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Center,
  Heading,
  Icon,
  Image,
  HStack,
  Divider,
} from '@chakra-ui/react';
import authAtom from '~/recoil/atom/auth';
import mediaQueryStateAtom from '~/recoil/atom/mediaQueryState';
import { useRecoilValue } from 'recoil';

import { IoQrCodeSharp } from 'react-icons/io5';

import qrcode from 'qrcode';
import { useEffect, useState } from 'react';
import { ContainerOwner } from '~/types/common';

type QRCodeModalProps = {
  isOpen: boolean;
  onClose: () => void;
  returnList: Array<{ id: string; name: string; count: number }>;
};

// 回收驗證碼modal：按下按鈕會跳出modal視窗，可以輸入給工作人員掃描確認歸還
export default function QRCodeModal({ isOpen, returnList, onClose }: QRCodeModalProps) {
  const { isLargerThan768 } = useRecoilValue(mediaQueryStateAtom);
  const auth = useRecoilValue(authAtom);

  const returnContainerCount = returnList.reduce((prev, { count }) => prev + count, 0);
  const [qrCodeString, setQrCodeString] = useState<string>('');

  const generateQrcode = async () => {
    const qrcodeCanvas = await qrcode.toDataURL(
      `return_${JSON.stringify({
        type: ContainerOwner.CUSTOMER,
        uid: auth?.uid || '',
        containers: returnList.map(({ id, count }) => ({ id, count })),
      })}`,
    );
    setQrCodeString(qrcodeCanvas);
  };

  useEffect(() => {
    generateQrcode();
  }, [returnList]);

  if (isLargerThan768) {
    return (
      <Modal isOpen={isOpen} onClose={onClose} size={'lg'} isCentered scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent m={0} h="100%" maxH={{ base: '100%', md: '100%' }}>
          <ModalHeader borderColor="primary" borderBottomWidth="1px">
            <Center mt={4}>
              <Icon as={IoQrCodeSharp} mr={3} color="primary" />
              <Text fontSize="xl" fontWeight="normal">
                您的回收驗證碼
              </Text>
            </Center>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack p={4} spacing={4} align="stretch">
              <Heading textAlign="center" fontSize="xl">
                請工作人員掃碼確認歸還
              </Heading>

              <Text textAlign="center">
                請將您的回收驗證碼給工作人員掃描
                <br />
                確認您的餐盒已全數歸還
              </Text>

              {/** QRCode Block */}
              <VStack
                alignSelf="center"
                spacing={2}
                borderColor="primary"
                borderWidth="4px"
                borderRadius="18px"
                px={12}
                pt={8}
                pb={2}
              >
                <Image src={qrCodeString} w="250px" h="250px" />
                <Text fontSize="md" textAlign="center">
                  *也可透過告知店家您的<b>手機號碼</b>
                  <br />
                  進行認證
                </Text>
              </VStack>

              <VStack spacing={0} align="stretch" fontSize="sm">
                <HStack
                  align="stretch"
                  justify="space-between"
                  bgColor="fontColor"
                  borderTopRadius="5px"
                  py={2}
                  px={4}
                  fontWeight="bold"
                >
                  <Text color="white">歸還清單</Text>
                  <Text color="white">{returnContainerCount}</Text>
                </HStack>

                <VStack
                  px={2}
                  align="stretch"
                  borderBottomRadius="5px"
                  borderTop="none"
                  borderColor="gray.400"
                  borderWidth="1px"
                  divider={<Divider />}
                  spacing={0}
                  maxH="200px"
                  overflowY="scroll"
                >
                  {returnList.map(({ name, id, count }) => (
                    <HStack justify="space-between" p={2} key={id}>
                      <Text>{name}</Text>
                      <Text>{count}</Text>
                    </HStack>
                  ))}
                </VStack>
              </VStack>
            </VStack>
          </ModalBody>
          <ModalFooter p={0} pos="relative">
            <VStack bg="#F7EFE3" w="full" borderTopRadius="20px" p={6} spacing={1}>
              <Heading size="sm" color="secondary">
                小提醒
              </Heading>
              <Text fontSize="sm" color="secondary" align="center">
                如工作人員正在繁忙中，
                <br /> 您也可以留下手機號碼與歸還餐盒類別與數量，
                <br /> 方便工作人員之後確認您的歸還數量
              </Text>
            </VStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }
  return (
    <Drawer isOpen={isOpen} onClose={onClose} size="full">
      <DrawerOverlay />
      <DrawerContent h="full">
        <DrawerCloseButton />
        <DrawerHeader borderColor="primary" borderBottomWidth="1px">
          <Center mt={4}>
            <Icon as={IoQrCodeSharp} mr={3} color="primary" />
            <Text fontSize="xl" fontWeight="normal">
              您的回收驗證碼
            </Text>
          </Center>
        </DrawerHeader>
        <DrawerBody>
          <VStack p={4} spacing={4} align="stretch">
            <Heading textAlign="center" fontSize="xl">
              請工作人員掃碼確認歸還
            </Heading>

            <Text textAlign="center">
              請將您的回收驗證碼給工作人員掃描
              <br />
              確認您的餐盒已全數歸還
            </Text>

            {/** QRCode Block */}
            <VStack
              alignSelf="center"
              spacing={2}
              borderColor="primary"
              borderWidth="4px"
              borderRadius="18px"
              px={12}
              pt={8}
              pb={2}
            >
              <Image src={qrCodeString} w="250px" h="250px" />
              <Text fontSize="md" textAlign="center">
                *也可透過告知店家您的<b>手機號碼</b>
                <br />
                進行認證
              </Text>
            </VStack>

            <VStack spacing={0} align="stretch" fontSize="sm">
              <HStack
                align="stretch"
                justify="space-between"
                bgColor="fontColor"
                borderTopRadius="5px"
                py={2}
                px={4}
                fontWeight="bold"
              >
                <Text color="white">歸還清單</Text>
                <Text color="white">{returnContainerCount}</Text>
              </HStack>
              <VStack
                px={2}
                align="stretch"
                borderBottomRadius="5px"
                borderTop="none"
                borderColor="gray.400"
                borderWidth="1px"
                divider={<Divider />}
                spacing={0}
                maxH="200px"
                overflowY="scroll"
              >
                {returnList.map(({ name, id, count }) => (
                  <HStack justify="space-between" p={2} key={id}>
                    <Text>{name}</Text>
                    <Text>{count}</Text>
                  </HStack>
                ))}
              </VStack>
            </VStack>
          </VStack>
        </DrawerBody>
        <DrawerFooter p={0}>
          <VStack bg="#F7EFE3" w="full" borderTopRadius="20px" p={6} spacing={1}>
            <Heading size="sm" color="secondary">
              小提醒
            </Heading>
            <Text fontSize="sm" color="secondary" align="center">
              如工作人員正在繁忙中，
              <br /> 您也可以留下手機號碼與歸還餐盒類別與數量，
              <br /> 方便工作人員之後確認您的歸還數量
            </Text>
          </VStack>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
